import { is_attr } from "../utilities/attributes";
import { activate, modalContainer } from "../template-parts/modals";
import { getAll, get } from "../utilities/querySelector";
import { textToHTML } from "../utilities/textToHtml";

const modal = get( '[data-modal=inspiration]', modalContainer );
const close = get( '[data-modal-close]', modalContainer );

const title_slot = get( '[data-inspo-title]', modal );
const content_slot = get( '[data-inspo-content]', modal );
const gallery_slot = get( '[data-inspo-gallery]', modal );
const desc_toggle = get( '[data-inspo-desc-toggle]', modal );

let content_snippet = '';
let full_content = '';

const items = getAll( '[data-inspo-card]' );

items.forEach( setUpModalEvents );
desc_toggle.addEventListener( 'click', toggleDescription );

function setUpModalEvents( item ) {
    const trigger = get( '[data-inspo-open]', item );

    trigger.addEventListener( 'click', () => {
        clearGallery();
        assignSlots( item );
        activate( 'inspiration' );
    } );

    close.addEventListener( 'click', resetDescription );
}


function assignSlots( item ) {
    const title = get( '[data-inspo-title]', item );
    const content = get( '[data-inspo-content]', item );

    full_content = content.innerHTML;
    content_snippet = getSnippet( full_content );

    title_slot.innerHTML = title.innerHTML;
    content_slot.innerHTML = content_snippet;
    assignGallery( item );
}

function resetDescription() {
    content_slot.setAttribute( 'aria-hidden', true );
    desc_toggle.setAttribute( 'aria-expanded', false );
    closeDescription();
}

function toggleDescription() {
    if ( is_attr( 'aria-expanded', desc_toggle ) ) {
        openDescription();
    } else {
        closeDescription();
    }
}

function closeDescription() {
    const text = get( '.button__text', desc_toggle );
    const arrow = get( 'svg', desc_toggle );
    content_slot.innerHTML = content_snippet;
    text.innerHTML = "Read more";
    arrow.style.rotate = "180deg";

}

function openDescription() {
    const text = get( '.button__text', desc_toggle );
    const arrow = get( 'svg', desc_toggle );
    content_slot.innerHTML = full_content;
    text.innerHTML = "Read less";
    arrow.style.rotate = "0deg";
}

async function assignGallery( item ) {
    const ids = item.dataset.gallery;
    const gallery = await fetchGalleryHtml( ids );
    if ( gallery === null ) {
        errorGallery();
        return console.error( "No html was returned" );
    };
    if ( gallery instanceof Error ) {
        errorGallery();
        return console.error( gallery );
    };
    gallery_slot.appendChild( gallery );
    slickSlideGallery( gallery );
}

function errorGallery() {
    gallery_slot.innerHTML = `
        <p class="inspodal__error">Failed to load image gallery</p>
    `;
}

function clearGallery() {
    gallery_slot.innerHTML = '';
}

async function fetchGalleryHtml( ids ) {
    try {
        const res = await fetch( `${WPObj.ajaxurl}?action=nu_gallery&image_ids=${ids}` );
        if ( !res.ok ) {
            console.dir( res );
            return new Error( 'Response is not ok' );
        };
        const text = await res.text();
        return textToHTML( text );
    } catch ( e ) {
        console.err( e );
        return e;
    }
}


function slickSlideGallery( gallery ) {
    const main = get( '[data-main]', gallery );
    const thumbs = get( '[data-thumbslider]', gallery );
    const prevArrow = get( '[data-prev]', gallery );
    const nextArrow = get( '[data-next]', gallery );
    jQuery( main ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: false,
        rows: 0,
        asNavFor: thumbs
    } );
    jQuery( thumbs ).slick( {
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        asNavFor: main,
        autoplay: false,
        dots: false,
        fade: false,
        arrows: true,
        rows: 0,
        prevArrow,
        nextArrow,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    } );
}

function getSnippet( content ) {
    const i = content.indexOf( ' ', 100 );
    return content.substring( 0, i ) + '...';
}